import { Component } from '@angular/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'orders-missing-hidden-required-field-banner',
  imports: [GalaxyAlertModule, TranslateModule],
  templateUrl: './missing-hidden-required-field-banner.component.html',
})
export class MissingHiddenRequiredFieldBannerComponent {}
